import React, { ComponentType, SVGProps } from 'react';
import styled from 'styled-components';
import { mq, TinyTitleBold, ButtonSmallTextStyle } from '@kvdbil/components';
import { useIsDevice } from '../../hooks/useIsDevice';

const StyledChip = styled.div`
  display: flex;
  padding: 0.375rem 0.5rem;
  align-items: center;
  gap: 0.5rem;
  background-color: ${({ theme }) => theme.colors.grayscaleToned.light6};
  border-radius: 1rem;

  ${mq('tablet')} {
    border-radius: 1.5rem;
  }
`;

const MobileLabel = styled(TinyTitleBold).attrs({ as: 'span' })``;

const DesktopLabel = styled.span`
  ${ButtonSmallTextStyle}
`;

export interface CardTagProps {
  text: string;
  icon: ComponentType<SVGProps<SVGSVGElement>>;
}

export const CardTag = ({ text, icon: Icon }: CardTagProps) => {
  const { isMobile } = useIsDevice();
  const Label = isMobile ? MobileLabel : DesktopLabel;
  const iconSize = isMobile ? '1rem' : '0.75rem';

  return (
    <StyledChip>
      <Icon width={iconSize} height={iconSize} />
      <Label>{text}</Label>
    </StyledChip>
  );
};

export default CardTag;
